import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { humanCapabilityProducts } from '../../data/home';
import { fadeUp } from '../../utils/motion';
export function HomeEcosystem() {
  return <section className="bg-surface-bg py-20 lg:py-28" data-id="element-1123" data-mp="2xelgpl7kwg6k">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1124" data-mp="32c3imrn6hv52">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 mb-14" data-id="element-1125" data-mp="32aamw7e3svbu">
          <h2 className="lg:col-span-5 font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight" data-id="element-1126" data-mp="24mid8dxv01nd">
            The SyNeural ecosystem
          </h2>
          <p className="lg:col-span-7 text-xl text-ink-dark leading-relaxed lg:pt-2" data-id="element-1127" data-mp="2elrbvk3o64g2">
            Noetivra is where people and organizations explore SyNeural’s
            connected knowledge and put its capability frameworks into practice.
            It draws on SKP’s approved knowledge and can provide access to Human
            Capability modules, including CJI and NCJI.
          </p>
        </motion.div>

        {/* Noetivra: the application layer */}
        <motion.div {...fadeUp} className="bg-navy-deep text-white rounded-lg p-8 lg:p-10 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16" data-id="element-1128" data-mp="c6cpbe9b9nh7">
          <div className="lg:col-span-5" data-id="element-1129" data-mp="7d9tt0kz43yd">
            <p className="text-sm font-medium text-teal mb-2" data-id="element-1130" data-mp="2gt6g8llltmc">Interactive workspace · Coming soon</p>
            <h3 className="font-heading font-bold text-3xl" data-id="element-1131" data-mp="3uklp59wfh3x7">Noetivra</h3>
          </div>
          <div className="lg:col-span-7" data-id="element-1132" data-mp="3pl8z6ga9fgqe">
            <p className="text-white/80 leading-relaxed mb-6" data-id="element-1133" data-mp="3pjee91yznomb">
              A modular, visual workspace for connected knowledge, assessments,
              and collaborative decisions.
            </p>
            <a href="/noetivra" className="inline-flex items-center gap-1.5 text-sm font-semibold text-white hover:text-teal transition-colors duration-150 whitespace-nowrap" data-id="element-1134" data-mp="3focqoakd2ulu">
              Explore Noetivra
              <ArrowRight size={14} aria-hidden="true" data-id="element-1135" data-mp="38bwyqse70e5n" />
            </a>
          </div>
        </motion.div>

        {/* What Noetivra draws on */}
        <motion.div {...fadeUp} className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1136" data-mp="3d3y928rsvut1">
          <div className="bg-white border border-line rounded-lg p-8 lg:p-10 flex flex-col" data-id="element-1137" data-mp="2yesamn0se8m7">
            <p className="text-sm font-medium text-teal mb-2" data-id="element-1138" data-mp="33dlpairt85ny">Supplies Noetivra’s knowledge</p>
            <h3 className="font-heading font-bold text-2xl text-ink-dark mb-3" data-id="element-1139" data-mp="3r36a777ixczv">Semantic Knowledge Platform</h3>
            <p className="text-ink-muted leading-relaxed mb-8" data-id="element-1140" data-mp="3vzwrfxv2eemv">
              The knowledge infrastructure that connects and governs concepts,
              relationships, sources, and approved knowledge, with semantic
              search and AI-assisted discovery.
            </p>
            <a href="/semantic-knowledge" className="mt-auto inline-flex items-center gap-1.5 text-sm font-semibold text-navy hover:text-teal transition-colors duration-150 whitespace-nowrap" data-id="element-1141" data-mp="26m1kmu9p5g5e">
              Explore SKP
              <ArrowRight size={14} aria-hidden="true" data-id="element-1142" data-mp="1y5asttnjr3vr" />
            </a>
          </div>

          <div className="lg:col-span-2 bg-white border border-line rounded-lg p-8 lg:p-10 flex flex-col" data-id="element-1143" data-mp="1y7n7nxy0cy4l">
            <div className="flex flex-wrap items-baseline justify-between gap-4 mb-3" data-id="element-1144" data-mp="2d075cj2e2den">
              <div data-id="element-1145" data-mp="281dw52u4x8ka">
                <p className="text-sm font-medium text-teal mb-2" data-id="element-1146" data-mp="1kdmhhsl4gjfu">Accessible through Noetivra’s Human Capability modules</p>
                <h3 className="font-heading font-bold text-2xl text-ink-dark" data-id="element-1147" data-mp="1ffknwdq2l1q4">Human Capability Framework</h3>
              </div>
              <a href="/human-capability" className="inline-flex items-center gap-1.5 text-sm font-semibold text-navy hover:text-teal transition-colors duration-150 whitespace-nowrap" data-id="element-1148" data-mp="1u58n99eoxqb7">
                Framework overview
                <ArrowRight size={14} aria-hidden="true" data-id="element-1149" data-mp="wp39le5zi8oa" />
              </a>
            </div>
            <p className="text-ink-muted leading-relaxed max-w-2xl mb-8" data-id="element-1150" data-mp="3w2u9f9qyulln">
              Developing reasoning, judgment, and readiness for responsibility.
              The framework defines assessment and development through CJI and
              NCJI.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-0 md:divide-x divide-line border-t border-line pt-8 mt-auto" data-id="element-1151" data-mp="8vrwa1ubeohy">
              {humanCapabilityProducts.map((product, index) => <div key={product.acronym} className={`flex flex-col ${index === 0 ? 'md:pr-8' : 'md:pl-8'}`} data-id="element-1152" data-mp="nmhaze6zilqk" data-mpi={index}>
                  <p className="font-heading font-extrabold text-2xl text-navy" data-id="element-1153" data-mp="roccojstv14v">{product.acronym}</p>
                  <p className="text-sm font-medium text-ink-dark mt-1 mb-3" data-id="element-1154" data-mp="wmxbqfwcferq">{product.name}</p>
                  <p className="text-ink-muted leading-relaxed mb-5" data-id="element-1155" data-mp="2tfpdoxrocovn">{product.body}</p>
                  <a href={product.link} className="mt-auto inline-flex items-center gap-1.5 text-sm font-semibold text-navy hover:text-teal transition-colors duration-150" data-id="element-1156" data-mp="2yek7eur6jxuj">
                    Explore {product.acronym}
                    <ArrowRight size={14} aria-hidden="true" data-id="element-1157" data-mp="2m281qlmiibll" />
                  </a>
                </div>)}
            </div>
          </div>
        </motion.div>

        <motion.p {...fadeUp} className="mt-14 text-2xl text-ink-dark leading-relaxed max-w-4xl" data-id="element-1158" data-mp="2c7g1tb5gjcnn">
          Together, these efforts support a larger goal: people who can reason
          well, knowledge that can be examined and connected, and institutions
          equipped to make responsible decisions.
        </motion.p>
      </div>
    </section>;
}